export default __webpack_public_path__ + "static/media/announcement.a9cb2946.svg";